export default "__VITE_ASSET__6fce512b__"